<template>
  <div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <h4>
            เติม-ถอน เครดิต
            <small>หากต้องการลบเครดิต ให้เติม - ข้างหน้ายอดเงิน</small>
          </h4>
          <br>
          <div class="mt-8">
            <vs-input
              class="w-full"
              label-placeholder="เลือกเว็บในเครือ"
              :value = "currentWebsite.label"
              disabled
            />
          </div>
          <div class="mt-8">
            <vs-input
              class="w-full"
              v-validate="'required|alpha_num'"
              label-placeholder="ยูสเซอร์เนม"
              v-model="username"
              name="username"
            />
            <span class="text-danger text-sm" v-show="errors.has('username')">{{
              errors.first("username")
            }}</span>
          </div>
          <div class="mt-8">
            <vs-input
              class="w-full"
              v-validate="'required|decimal'"
              label-placeholder="จำนวนเงิน"
              v-model="amount"
              name="amount"
            />
            <span class="text-danger text-sm" v-show="errors.has('amount')">{{
              errors.first("amount")
            }}</span>
          </div>
          <div class="mt-8">
            <vs-input
              class="w-full"
              v-validate="'required|decimal'"
              label-placeholder="เทิร์นที่ลูกค้าต้องทำ"
              v-model="turnover"
              name="turnover"
            />
            <span class="text-danger text-sm" v-show="errors.has('turnover')">{{
              errors.first("turnover")
            }}</span>
          </div>
          <div class="mt-8">
            <vs-input
              class="w-full"
              v-validate="'required|decimal'"
              label-placeholder="จำนวนอั้นถอน (ถ้าไม่มีใส่0)"
              v-model="limitWithdraw"
              name="limitWithdraw"
            />
            <span class="text-danger text-sm" v-show="errors.has('limitWithdraw')">{{
              errors.first("limitWithdraw")
            }}</span>
          </div>
          <div class="mt-8">
            <label class="vs-input--label">เลือกประเภทการเติม</label>
            <vs-select class="w-full mt-4" v-model="typeforAddCredit">
              <vs-select-item
                :key="index"
                :value="item.code"
                :text="item.name"
                v-for="(item, index) in typeSelections"
              />
            </vs-select>
          </div>
          <div v-if="typeforAddCredit == 'Admin-BONUS'"  class="mt-8">
            <label class="vs-input--label">เลือกประเภทโบนัส</label>
            <vs-select class="w-full mt-4" v-model="typeforBonus">
              <vs-select-item
                :key="index2"
                :value="item.code"
                :text="item.name"
                v-for="(item, index2) in selectedBonus"
              />
            </vs-select>
          </div>
          <div class="mt-8">
            <vs-textarea
              class="w-full"
              v-validate="'required'"
              label="หมายเหตุ"
              v-model="info"
              name="info"
            />
            <span class="text-danger text-sm" v-show="errors.has('info')">{{
              errors.first("info")
            }}</span>
          </div>

          <label> อัพสลิปธนาคาร COPY & PASTE </label>
          <div class="mt-2">
            <vs-input
              class="inputx"
              placeholder="กรุณาวางรูป"
              :value="selectedFile.name"
              @paste="onPaste"
            />
            <div class="mt-4">
              <label class="vs-input--label">หรือเลือกไฟล์สลิปจากเครื่อง</label>
              <input class="mt-1" type="file" accept="image/*" @change="onFileChange" />
            </div>
            <vs-checkbox
              disabled="true"
              class="mt-2 mb-4"
              :color="chk_box.color"
              v-model="chk_box.data"
              >{{ chk_box.text }}</vs-checkbox
            >
            <canvas
              style="border: 4px solid grey"
              id="mycanvas"
              width="300px"
              height="300px"
            ></canvas>
          </div>

          <vs-button
          v-if="isLoading===false"
            color="success"
            type="relief"
            class="mt-8"
            @click="submit_credit"
            >เติมเงิน</vs-button >

            <vs-button
            v-else
            disabled
            color="success"
            type="relief"
            class="mt-8 .spinner-grow"
            >เติมเงิน</vs-button >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Validator} from 'vee-validate'
import axios from '../../axios'
const dict = {
  custom: {
    username: {
      required: 'กรุณากรอกข้อมูล',
      alpha_num: 'ตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น'
    },
    amount: {
      required: 'กรุณากรอกข้อมูล',
      decimal: 'ต้องเป็นตัวเลขหรือจุดทศนิยมเท่านั้น'
    },
    info: {
      required: 'กรุณากรอกข้อมูล'
    },
    fromWebsite: {
      required: 'กรุณาเลือกข้อมูลในช่อง'
    }
  }
}
// register custom messages
Validator.localize('en', dict)

export default {
  data () {
    return {
      username: '',
      isLoading:false,
      amount: '',
      turnover:0,
      limitWithdraw:0,
      info: '',
      previewImg:'',
      agent_error: {},
      bonusList:[],
      selectedFile: [],
      selectedBonus: [],
      typeforBonus:'non-promo',
      typeforAddCredit : 'Admin-TXN-TOPUP',
      typeSelections : [
        {
          code : 'Admin-HBD',
          name : 'โปรวันเกิด'
        },
        {
          code : 'Admin-10RD',
          name : 'แพ้/ชนะ 10 ตาติด'
        },
        {
          code : 'Admin-BONUS',
          name : 'เกี่ยวกับโบนัส'
        },
        {
          code : 'Admin-TXN-GAME',
          name : 'เกี่ยวกับรายการเล่น'
        },
        {
          code : 'Admin-TXN-TOPUP',
          name : 'เกี่ยวกับรายการฝาก'
        },
        {
          code : 'Admin-TEST',
          name : 'เกี่ยวกับการทดสอบระบบ'
        },
        {
          code : 'Admin-ETC',
          name : 'อื่นๆ (กรุณาใส่หมายเหตุให้ชัดเจน)'
        }

      ],
      chk_box: {text: 'กรุณาวางรูป', color: 'danger', data: false}
    }
  },
  async mounted () {
    await axios
      .get('agent/bonus')
      .then(response => (this.bonusList = response.data))
    this.selectedBonus = this.bonusList.map((item) => {
      return {
        code: item.bonus_code,
        name: item.bonus_name
      }
    })
  },
  computed: {
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  watch: {
    selectedFile () {
      if (this.selectedFile &&  this.selectedFile.name && this.selectedFile.name.length > 0) {
        this.chk_box.text = 'วางรูปสำเร็จ'
        this.chk_box.color = 'success'
        this.chk_box.data = true
      } else {
        this.chk_box.text = 'วางรูปไม่สำเร็จ'
        this.chk_box.color = 'danger'
        this.chk_box.data = false
      }
    }
  },
  methods: {
    async submit_credit () {
      this.isLoading = true
      this.$vs.loading()
      this.$validator.validateAll().then(async result => {
        if (result) {
          if (this.amount >= '0') {

            if (!this.selectedFile || !this.selectedFile.size) {
              this.isLoading = false
              this.$vs.loading.close()
              this.$vs.notify({
                time: 10000,
                color: 'danger',
                position: 'top-right',
                icon: 'error',
                title: 'ทำรายการไม่สำเร็จ',
                text: 'กรุณาอัพสลิปหรือภาพที่เกี่ยวข้องกับการเพิ่มเครดิต'
              })
              return
            }

            await axios.post('/agent/addcreditsolo', {
              username: this.username,
              balance: this.amount,
              info: this.info,
              type : this.typeforAddCredit,
              turnover:this.turnover,
              limitWithdraw:this.limitWithdraw,
              bonusCode:this.typeforBonus,
              fromWebsite : this.currentWebsite.value
            })
              .then(response => (this.agent_error = response.data))
            this.$vs.loading.close()

            if (this.agent_error.status === true) {
              this.isLoading = false
              await this.$vs.notify({
                time: 10000,
                color: 'success',
                position: 'top-right',
                icon: 'error',
                title: this.agent_error.info.title,
                text: this.agent_error.info.info
              })
              await this.onUploadFile()
              setTimeout(() => {
                window.location.reload()
              }, 1500)
            } else {
              this.isLoading = false
              this.$vs.notify({
                time: 10000,
                color: 'danger',
                position: 'top-right',
                icon: 'error',
                title: this.agent_error.info.title,
                text: this.agent_error.info.info
              })
            }
          } else {
            await axios.post('/agent/minuscredit', {
              username: this.username,
              balance: this.amount,
              info: this.info,
              fromWebsite : this.currentWebsite.value
            })
              .then(response => (this.agent_error = response.data))
            if (this.agent_error.status === true) {
              setTimeout(() => {
                window.location.reload()
              }, 1500)
              this.$vs.notify({
                time: 10000,
                color: 'warning',
                position: 'top-right',
                icon: 'error',
                title: this.agent_error.info.title,
                text: this.agent_error.info.info
              })
            } else {
              this.$vs.notify({
                time: 10000,
                color: 'danger',
                position: 'top-right',
                icon: 'error',
                title: this.agent_error.info.title,
                text: this.agent_error.info.info
              })

            }
          }
        } else {
          this.$vs.loading.close()
          this.$vs.notify({
            time: 3000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            title: 'ทำรายการไม่สำเร็จ',
            text: 'จำนวนเงินไม่สามารถเป็น 0 ได้'
          })
          this.isLoading = false
        }
        if (this.agent_error.status === true) {
          await axios.post('/line/agent', {
            username: this.username,
            balance: this.amount,
            info: this.info,
            admin: this.$store.state.AppActiveUser.username,
            fromWebsite : this.currentWebsite.value
          })
        }


      })
    },
    onFileChange (e) {
      const selectedFile = e.target.files[0]
      if (!selectedFile) return
      this.selectedFile = selectedFile
      this.drawPreview(selectedFile)
    },
    // วาด preview ลง canvas ตัวเดียวกับตอน copy & paste
    drawPreview (blob) {
      const canvas = document.getElementById('mycanvas')
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.onload = () => {
        const resizedWidth = 300
        const resizedHeight = (img.height / img.width) * resizedWidth
        canvas.width = resizedWidth
        canvas.height = resizedHeight
        ctx.drawImage(img, 0, 0, resizedWidth, resizedHeight)
        URL.revokeObjectURL(img.src)
      }
      img.src = URL.createObjectURL(blob)
    },
    async onUploadFile () {
      // ไม่ได้วางสลิปมา ก็ไม่ต้องยิง (เดิมยิง field file เป็นค่าว่างขึ้นไป)
      if (!this.selectedFile || !this.selectedFile.size) return

      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('topupid', this.agent_error.data)
      formData.append('fromWebsite', this.currentWebsite.value)

      // sending file to the backend
      try {
        await axios.post('upload/upload', formData)
      } catch (err) {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'อัพสลิปไม่สำเร็จ',
          text: 'เครดิตเข้าแล้ว แต่รูปสลิปไม่ถูกบันทึก กรุณาอัพสลิปใหม่'
        })
      }
    },
    retrieveImageFromClipboardAsBlob (pasteEvent, callback) {
      if (pasteEvent.clipboardData === false) {
        if (typeof (callback) === 'function') {
          callback(undefined)
        }
      }

      const items = pasteEvent.clipboardData.items

      if (items === undefined) {
        if (typeof (callback) === 'function') {
          callback(undefined)
        }
      }

      for (let i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf('image') === -1) continue
        // Retrieve image on clipboard as blob
        const blob = items[i].getAsFile()

        if (typeof (callback) === 'function') {
          callback(blob)
          this.selectedFile = blob
        }
      }
    },
    onPaste (evt) {
      // console.log('on paste', evt)
      // Handle the event
      this.retrieveImageFromClipboardAsBlob(evt, function (imageBlob) {
        // If there's an image, display it in the canvas
        if (imageBlob) {
          const canvas = document.getElementById('mycanvas')
          const ctx = canvas.getContext('2d')

          // Create an image to render the blob on the canvas
          const img = new Image()

          // Once the image loads, render the img on the canvas
          img.onload = function () {
            // Update dimensions of the canvas with the dimensions of the image


            // Draw the resized image
            const resizedWidth = 300 // Adjust the resized width as needed
            const resizedHeight = (img.height / img.width) * resizedWidth

            canvas.width = resizedWidth
            canvas.height = resizedHeight

            ctx.drawImage(img, 0, 0, resizedWidth, resizedHeight)
            // Draw the image


            // Display a smaller version of the image
            const thumbnailCanvas = document.getElementById('thumbnailCanvas')
            const thumbnailCtx = thumbnailCanvas.getContext('2d')

            const thumbnailSize = 100 // Adjust the size as needed
            thumbnailCanvas.width = thumbnailSize
            thumbnailCanvas.height = thumbnailSize
            thumbnailCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, thumbnailSize, thumbnailSize)
          }


          // Crossbrowser support for URL
          const URLObj = window.URL || window.webkitURL

          // Creates a DOMString containing a URL representing the object given in the parameter
          // namely the original Blob
          img.src = URLObj.createObjectURL(imageBlob)
        }
      })
    }

  }
}
</script>
